import React from 'react';
import renderHTML from 'html-react-parser';
import { IMAGE_BASE_LINK } from '../../../../app-constants';
import { stripStartingAndEndingPTags } from '../../../ssm-homepage/ssm-homepage.actions';
import './header-with-image.css';

const HeaderWithImage = (props) => {
  const { title, text, image } = props;
  return (
    <div className="row ffwd-header view-header">
      <div className={`${(image !== undefined && image !== '') ? 'col-lg-4' : 'col-lg-12'} col-sm-12 pl-sm-0 pr-sm-0`}>
        <h1 id="main-heading" className="heading">{title}</h1>
        <p id="main-description" className="description">{renderHTML(stripStartingAndEndingPTags(text))}</p>
      </div>
      {image !== undefined && image !== '' &&
      <div className="col-lg-8 col-sm-12 pl-sm-0 pr-sm-0 header-right-img">
        <img alt={image} src={`${IMAGE_BASE_LINK}/${image}`} />
      </div>
      }
    </div>
  );
};

export default HeaderWithImage;
